import { API } from "@/js/accounts/utils/api.js";

export default () => ({
    logout() {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        API.POST.logout(csrfToken)
            .then(() => {
                window.location.href = '/account/login/';
            })
            .catch(error => {
                console.error('Logout failed:', error);
            });
    }
});
